import { createFileRoute } from "@tanstack/react-router";
import { RuleSetDetail } from "@/components/data-quality/rule-set-screens";
import { maskRuleSets } from "@/api/data-quality";

export const Route = createFileRoute("/_app/data-quality/pii/$id")({
  component: PiiDetail,
});

function PiiDetail() {
  const { id } = Route.useParams();
  return (
    <RuleSetDetail
      kind="mask"
      query={maskRuleSets.useOne(id)}
      save={maskRuleSets.useSave()}
      remove={maskRuleSets.useRemove().mutateAsync}
      crumbs={[
        { label: "Data Quality", to: "/data-quality" },
        { label: "PII Masking", to: "/data-quality/pii" },
      ]}
      backTo="/data-quality/pii"
    />
  );
}
